import styled from 'styled-components';
import colors from 'styles/colors';
import { FormWrapper } from 'styles/form';

export const Section = styled.div`
  border-bottom: 1px solid ${colors.gray80};
  padding-bottom: 35px;
  margin-bottom: 20px;

  &:last-child {
    border: 0;
  }
  ${FormWrapper} {
    width: 472px;
  }
`;

export const Description = styled.p`
  font-size: 12px;
  line-height: 17px;
  margin-top: 12px;
  margin-bottom: 16px;
  max-width: 500px;
`;
